import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { adaptItemToRequest } from './adapters/adaptItemToRequest';
import { defaultCurrencyCode } from './constants/defaultCurrency';
import { IItem } from './models/IItem';

interface IAddToCartEvent {
	items: IItem[];
	currency?: string;
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_additions_to_and_removals_from_shopping_carts
 */
export function trackAddToCart({ currency, items }: IAddToCartEvent) {
	trackWithGoogleAnalytics('event', 'add_to_cart', {
		items: items.map(adaptItemToRequest),
		currency: currency ?? defaultCurrencyCode,
	});
}
